import { motion } from "framer-motion";
import { Trophy } from "lucide-react";
import { DESTINATIONS } from "../../game/destinations";
import { CHALLENGE_TITLES, challengeOutcome } from "../../lib/challenge";
import { useIslandHistory, usePersonalRecord } from "./usePersonalRecord";
import { CHALLENGE_POP, RECORD_POP } from "./motionPresets";

export const IslandHistory = ({ destinationIndex }) => {
  const history = useIslandHistory(destinationIndex);
  if (history.length < 2) return null;
  return (
    <div className="mt-4 text-center" data-testid="island-history">
      <p className="label-mono text-[#506780] mb-2">Ultime partite</p>
      <ol className="flex flex-wrap justify-center gap-1.5">
        {history.map((idx, i) => (
          <li
            key={`${idx}-${i}`}
            data-testid={`island-history-${i}`}
            className={`rounded-full px-3 py-1 text-xs font-bold ${
              i === 0 ? "bg-[#A989FF] text-[#14233D]" : "bg-white border border-[#D0E4F3] text-[#14233D]/80"
            }`}
          >
            {DESTINATIONS[idx].name}
          </li>
        ))}
      </ol>
    </div>
  );
};

export const ReachedStat = ({ percent, island }) => (
  <p className="text-center font-display text-lg text-[#14233D] mt-6 leading-snug" data-testid="result-percentile">
    {percent <= 50 ? "Solo il " : "Il "}
    <span className="text-pop">{percent}%</span> dei giocatori è arrivato fino a {island}.
  </p>
);

const OUTCOMES = {
  win: { cls: "bg-[#55D7F3]", text: (i) => `Hai superato il tuo amico, fermo a ${i}.` },
  draw: { cls: "bg-white", text: (i) => `Anche il tuo amico si è fermato a ${i}.` },
  lose: { cls: "bg-[#F26DB5]", text: (i) => `Il tuo amico è arrivato a ${i}. Ritenta!` },
};

export const ChallengeOutcome = ({ challenge, destinationIndex }) => {
  const key = challengeOutcome(challenge, destinationIndex);
  const o = OUTCOMES[key];
  return (
    <motion.div
      {...CHALLENGE_POP}
      className={`${o.cls} text-[#14233D] rounded-[24px] px-5 py-3 mb-6 text-center`}
      data-testid="challenge-outcome"
      data-outcome={key}
    >
      <p className="font-display text-2xl leading-none">{CHALLENGE_TITLES[key]}</p>
      <p className="text-[13px] font-semibold mt-1.5">{o.text(challenge.island)}</p>
    </motion.div>
  );
};

export const PersonalRecord = ({ destinationIndex }) => {
  const { best, previous, isNew } = usePersonalRecord(destinationIndex);
  return (
    <div className="mt-6 flex justify-center" data-testid="personal-record">
      {isNew ? (
        <motion.div
          {...RECORD_POP}
          className="rounded-full bg-[#FFD166] text-[#14233D] px-5 py-2 flex items-center gap-2 shadow-[0_5px_0_#B9800E]"
          data-testid="new-record-badge"
        >
          <Trophy size={18} />
          <span className="font-display text-base">NUOVO RECORD!</span>
          <span className="text-xs font-semibold">prima: {DESTINATIONS[previous].name}</span>
        </motion.div>
      ) : (
        <p className="rounded-full bg-white border border-[#D0E4F3] px-4 py-1.5 text-sm font-semibold text-[#14233D] flex items-center gap-2">
          <Trophy size={15} className="text-[#9A6A00]" />
          Il tuo record: <span className="font-display text-[#9A6A00]" data-testid="personal-record-island">{DESTINATIONS[best].name}</span>
        </p>
      )}
    </div>
  );
};
